export default __webpack_public_path__ + "static/media/CL13.a62c89fb.mp3";